import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { ScrollToTop } from 'components/layout';
import MaintenancePage from 'pages/MaintenancePage';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AutoRefreshingRouter } from 'utils/AutoRefreshingRouter';
import App from './App';
import './index.css';
import store from './store';

if (process.env.REACT_APP_SENTRY_ENABLE === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    {process.env.REACT_APP_MAINTENANCE_MODE === 'true' ? (
      <MaintenancePage />
    ) : (
      <AutoRefreshingRouter>
        <Provider store={store}>
          <ScrollToTop />
          <App />
        </Provider>
      </AutoRefreshingRouter>
    )}
  </React.StrictMode>,
  document.getElementById('root')
);
